import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_ascending",
  "use": "sort_ascending-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"sort_ascending\"><path d=\"M4.97 6.47c-.29.29-.29.77 0 1.06s.77.29 1.06 0l2.22-2.22V15c0 .41.34.75.75.75s.75-.34.75-.75V5.31l2.22 2.22c.29.29.77.29 1.06 0 .15-.15.22-.34.22-.53s-.07-.38-.22-.53L9 2.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol